document.addEventListener('DOMContentLoaded', () => {
  loadVideoComponentEventListeners();
});

function loadVideoComponentEventListeners() {
  const reducedMotionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('.video-container').forEach((videoContainer) => {
    if (videoContainer.hasAttribute('data-has-overlay')) {
      let video = videoContainer.querySelector('.mhe-video-comp');
      let videoOverlay = videoContainer.querySelector('.video-overlay-content-container');
      let playPauseBtn =
        videoContainer.querySelector('.mhe-play-pause-video-btn') ||
        (videoContainer.parentElement && videoContainer.parentElement.querySelector('.mhe-play-pause-video-btn'));
      if (!playPauseBtn || !video) {
        return;
      }
      let videoTitle = videoContainer.dataset.videoTitle;
      const playBtnText = videoTitle ? `Play video: ${videoTitle}` : 'Play video';
      const pauseBtnText = videoTitle ? `Pause video: ${videoTitle}` : 'Pause video';
      playPauseBtn.setAttribute('aria-label', video.paused ? pauseBtnText : playBtnText);
      let clickListener = function () {
        if (video && playPauseBtn) {
          if (video.paused) {
            video.play();
            playPauseBtn.querySelector('uxt-icon').setAttribute('icon', 'pause');
            playPauseBtn.setAttribute('aria-label', pauseBtnText);
          } else {
            video.pause();
            playPauseBtn.querySelector('uxt-icon').setAttribute('icon', 'play');
            playPauseBtn.setAttribute('aria-label', playBtnText);
          }
        }
      };
      if (videoOverlay && videoOverlay.contains(playPauseBtn)) {
        videoOverlay.addEventListener('click', clickListener);
      } else {
        playPauseBtn.addEventListener('click', clickListener);
      }
      if (reducedMotionPreference.matches) {
        playPauseBtn.querySelector('uxt-icon').setAttribute('icon', 'play');
        playPauseBtn.setAttribute('aria-label', playBtnText);
      }
    }
  });
  if (reducedMotionPreference.matches) {
    let videos = document.querySelectorAll('.mhe-video-comp');
    videos.forEach((video) => {
      if (video.getAttribute('autoplay')) {
        video.setAttribute('autoplay', false);
        video.pause();
      }
    });
  }
}
